import { call, put, takeLatest, all } from 'redux-saga/effects';
import { getSolutions } from '4ff-lib-foundation/lib/AppFrame/publicAPI/store';
import i18next from 'i18next';
import {
  GET_SITEMAP_PENDING,
  GET_SITEMAP_SUCCESS,
  GET_SITEMAP_FAILURE,
} from '../actions';
import { errorSnack } from '../services/snacks';

export function sortDESCbyWeight(a, b) {
  return b.weight - a.weight;
}

export function orderSitemap(menu) {
  return menu
    .sort(sortDESCbyWeight)
    .reduce((acc, x) => {
      const s = {
        ...x,
        children: x.children ? x.children.sort(sortDESCbyWeight) : [],
      };

      return [...acc, s];
    }, []);
}

export function* getSitemap() {
  try {
    const subtree = getSolutions();
    const orderedSitemap = yield call(orderSitemap, subtree);
    yield put({ type: GET_SITEMAP_SUCCESS, payload: orderedSitemap });
  } catch (error) {
    yield put({ type: GET_SITEMAP_FAILURE, payload: { error: error.message } });

    let text = error.message;
    if (error.response && error.response.status === 403) {
      text = i18next.t('LPBD.accessDenied');
    }

    yield call(errorSnack, { text });
  }
}

// eslint-disable-next-line
export default function () {
  return all([
    takeLatest(GET_SITEMAP_PENDING, getSitemap),
  ]);
}
